export const LOCAL_STORAGE_KEYS = {
	CAME_FROM_SEND_STEP: 'cameFromSendStep',
	CAME_FROM_NO_CONTACT_MODAL: 'cameFromNoContactModal',
} as const;
